module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('Tabs', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "on-click": _vm.handleTapChange
    },
    model: {
      value: (_vm.tabsValue),
      callback: function($$v) {
        _vm.tabsValue = $$v
      },
      expression: "tabsValue"
    }
  }, _vm._l((_vm.cpList2), function(item, index) {
    return _c('TabPane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.name
      }
    })
  }), 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formFuzzy
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "输入图书名称"
    },
    model: {
      value: (_vm.formFuzzy.bookName),
      callback: function($$v) {
        _vm.$set(_vm.formFuzzy, "bookName", $$v)
      },
      expression: "formFuzzy.bookName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "输入出版社名称"
    },
    model: {
      value: (_vm.formFuzzy.pressName),
      callback: function($$v) {
        _vm.$set(_vm.formFuzzy, "pressName", $$v)
      },
      expression: "formFuzzy.pressName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "输入ISBN值"
    },
    model: {
      value: (_vm.formFuzzy.IsbnName),
      callback: function($$v) {
        _vm.$set(_vm.formFuzzy, "IsbnName", $$v)
      },
      expression: "formFuzzy.IsbnName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.onQuery
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "font-size": "12px"
    },
    attrs: {
      "data": _vm.queryData,
      "header-cell-style": _vm.rowClass,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "sort-change": _vm.tableSortChg
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "align": "center",
      "width": "110",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "图书名称",
      "align": "center",
      "min-width": "240",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6",
            "font-size": "13px"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.viewHowEdit(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dbName",
      "label": "内容提供商",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clevel",
      "label": "当前状态",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.clevel == 0) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已下架")]) : (scope.row.clevel == 4) ? _c('el-tag', {
          attrs: {
            "type": "gray"
          }
        }, [_vm._v("审核通过")]) : (scope.row.clevel == 5) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已上架")]) : (scope.row.clevel == 2) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("编辑中")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updated_at",
      "label": "更新时间",
      "align": "center",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("formatDate2")(scope.row.updated_at)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "editor",
      "label": "编辑账号",
      "width": "110",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": "",
      "align": "center",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "查看",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-reading",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.viewHowEdit(scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-copy-document"
    },
    on: {
      "click": _vm.borrowBook
    }
  }, [_vm._v("领取")]), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c1009be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/components/bookNewList.vue
// module id = 721
// module chunks = 1